import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from '../../../finance/finance.service';

@Component({
    selector: 'app-add-service-invoice',
    templateUrl: './add-service-invoice.component.html',
    styleUrls: ['./add-service-invoice.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddServiceInvoiceComponent implements OnInit {

	@Input() comment: any;
	@Input() element: any;
	@Input() type: string;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	values: any = {
		'id': '',
		'invoice': ''
	}

	close() {
		this.closeView.emit()
	}

	submitForm() {
		this.loading = true;
		if (this.type == 'service') {
			this._fiS.addServiceInvoice(this.values).subscribe(
				(data: any) => {
					this.notify.emit();
					this.loading = false;
				}
			);
		} else if (this.type == 'catering') {
			this._fiS.addDataCatering(this.values.id, this.values.invoice, 2).subscribe(
				(data: any) => {
					this.notify.emit();
					this.loading = false;
				}
			)
		}
	}

	fillForm() {
		this.values.invoice = this.element.invoice ? this.element.invoice : '';
		this.values.id = this.element.id;
	}

	constructor(private _fiS: FinanceService) { }

	ngOnInit() {
		this.fillForm();
	}

}
